import { resolveApiPath } from '@/app/constants';

/** GET /vidu/v1/cost 查询语音克隆消耗积分（biz_code，对应接口文档示例 "voice"） */
export const VOICE_CLONE_COST_BIZ_CODE = 'voice';

/** 任务列表单次拉取条数（与 `materialsListVoiceTasks` pager 对齐） */
export const VOICE_CLONE_TASKS_PAGE_SIZE = 20;

/** 页面允许同时追踪/提交的声音复刻任务数 */
export const VOICE_CLONE_MAX_PARALLEL_JOBS = 3;

// 录音限制
export const MIN_RECORDING_DURATION = 15; // 秒
export const MAX_RECORDING_DURATION = 40;
export const MAX_AUDIO_FILE_SIZE = 20 * 1024 * 1024; // 20MB

// 音色信息限制
export const MAX_VOICE_NAME_LENGTH = 30;
export const MAX_VOICE_DESCRIPTION_LENGTH = 200;

/** 与 `materialsGetVoiceStatus`（GET /vidu/v1/voices/status）一致，SSE 通过 query 传 voice_id */
export const VOICE_STATUS_SSE_PATH = resolveApiPath('/vidu/v1/voices/status');
